import { __awaiter } from "tslib";
class Dispatcher {
    install() {
        return (dispatch) => __awaiter(this, void 0, void 0, function* () {
            dispatch(this.installLazy());
        });
    }
    installLazy() {
        return (dispatch) => __awaiter(this, void 0, void 0, function* () { });
    }
}
const AppDispatcher = new Dispatcher();
export default AppDispatcher;
